module.exports = __webpack_public_path__ + "static/media/12.4b403275.jpg";